host.actions.register({
    // #region Vars
    name: '288a.commerce.cart.create',
    // #endregion
    // #region Entry
    async execute(data, params) {
        let tData = data ?? {};
        return this.Window(await host.notification.showModal2(host.components.getComponent('g-cart-create-dialog'), tData));
    },
    // #endregion
});
export {};
